document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-aylam-open-rewards]');
    if (!link) return;
    const smileButton = document.querySelector('[id*="__smile_io_smile_landing_page_header_"] button');
    if (smileButton) {
      event.preventDefault();
      smileButton.click();
    }
  });

// Smile renders the headline asynchronously and can replace it after sign-in.
const aylamRewardsHeaders = new WeakSet();
function mountAylamRewardsLabels() {
  document.querySelectorAll('[id*="__smile_io_smile_landing_page_header_"]').forEach((header) => {
    if (aylamRewardsHeaders.has(header)) return;
    aylamRewardsHeaders.add(header);
    const addLabel = () => {
      const heading = header.querySelector('h1');
      if (!heading || header.querySelector('.aylam-rewards__hero-label')) return;
      const label = document.createElement('div');
      label.className = 'aylam-rewards__hero-label';
      const dot = document.createElement('span');
      dot.className = 'aylam-rewards__status-dot';
      dot.setAttribute('aria-hidden', 'true');
      label.append(dot, document.createTextNode('Aylam Farm Rewards'));
      heading.before(label);
    };
    addLabel();
    new MutationObserver(addLabel).observe(header, { childList: true, subtree: true });
  });
}
mountAylamRewardsLabels();
document.addEventListener('shopify:section:load', mountAylamRewardsLabels);
